import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import React, { FC, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

interface ModalProps {
  isOpen: boolean;
  closeModal?: () => void;
  children: React.ReactNode;
  className?: string;
}

const Modal: FC<ModalProps> = ({ isOpen, closeModal, children, className }) => {
  const theme = useAtomValue(themeAtom);

  const [isBodyOverflowHidden, setIsBodyOverflowHidden] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsBodyOverflowHidden(true);
    }

    return () => {
      setIsBodyOverflowHidden(false);
    };
  }, [isOpen]);

  const modalClasses = twMerge("modal fixed inset-0 z-[1000] flex items-center justify-center", !isOpen && "hidden");

  return (
    <div className={modalClasses}>
      <div
        className={twMerge("modal-overlay absolute h-full w-full opacity-50", theme.home.tailwind.pageBackground)}
        onClick={closeModal}
      />

      <div
        className={twMerge(
          "modal-container z-50 mx-auto w-2/5 overflow-y-auto rounded shadow-lg",
          className,
          theme.headerComponent.notifications.drawerBackground,
        )}
        style={{ overflow: isBodyOverflowHidden ? "hidden" : "auto", zIndex: 1000 }}
      >
        <div className={twMerge("modal-content w-full px-6 py-4 text-left", theme.home.tailwind.textDefault)}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
